var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M38.2 46.1h36.5v13.7H38.2V32.6H56l.4 27.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M104.8 54.8V37l-19-17.4H28.6c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M85.9 19.7V37h18.9M113.5 103H79.9c-2.8 0-5.1-2.3-5.1-5.1V69c0-2.8 2.3-5.1 5.1-5.1h33.7c2.8 0 5.1 2.3 5.1 5.1v28.8c0 2.9-2.3 5.2-5.2 5.2zM102.1 77.1L92.6 90M92.6 77.1l9.5 12.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.fbdaa48a4d78db8032c15913e5033135.svg";
export { ForwardRef as ReactComponent };